// @mui material components
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import Projects from "layouts/dashboard/components/Projects";
import OrdersOverview from "layouts/dashboard/components/OrdersOverview";
import { useEffect, useState } from "react";
import {
  getTotalBookings,
  getChartData,
  getSubscriptionStatistics,
  returningUsers,
  topSellingRates,
  getLocationsRevenue,
} from "store/slice/homePage/homePageSlice";

import { useDispatch, useSelector } from "react-redux";
// import { useTheme } from "@mui/material/styles";
// import { useMaterialUIController } from "context";
import CircularIndeterminate from "components/MDLoading";
import MultiPlacePicker from "components/MDPlacePicker/MultiPlacePicker";
import { getCurrentMonthStatistics } from "store/slice/homePage/homePageSlice";
import { amountToShow } from "global/functions";
import { get } from "lodash";
import moment from "moment";
import PieChart from "examples/Charts/PieChart";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";
import { getPaymentMethodsRevenue } from "store/slice/homePage/homePageSlice";
import DockLandingPage from "./components/NoDashboardPermissionView";
import HorizontalBarChart from "examples/Charts/BarCharts/HorizontalBarChart";

function Dashboard() {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const SelectedPlaces = useSelector(
    (state) => state.places?.multiSelectedPlaces
  );
  const userData = useSelector((state) => state.users?.meInfo);
  const roleModules = userData?.roleModules || {};
  const placeIds = SelectedPlaces.map((place) => place?._id).filter(
    (id) => typeof id === "string" && id !== "undefined"
  );
  const token = useSelector((state) => state.auth.token);

  const {
    subscriptionStatistics,
    currentMonthStatistics,
    returningUsersData,
    topSellingRatesData,
    chartData,
    locationsRevenue,
    paymentMethodsRevenue,
    loading,
  } = useSelector((state) => state.dashboard);

  useEffect(() => {
    if (placeIds.length > 0 && SelectedPlaces.length > 0) {
      refreshDailyStats();
    }
  }, [SelectedPlaces]);

  const refreshDailyStats = async () => {
    try {
      await Promise.all([
        dispatch(getTotalBookings({ token, placeIds })),
        dispatch(returningUsers({ token, placeIds })),
        dispatch(topSellingRates({ token, placeIds })),
        dispatch(getCurrentMonthStatistics({ token, placeIds })),
        dispatch(getSubscriptionStatistics({ token, placeIds })),
        dispatch(getChartData({ token, placeIds })),
        dispatch(getLocationsRevenue({ token, placeIds })),
        dispatch(getPaymentMethodsRevenue({ token, placeIds })),
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!roleModules?.Dashboard_view ? (
        <>
          <DockLandingPage />
        </>
      ) : (
        <>
          <MultiPlacePicker notDefaultPlace={true} isDashboard={true} />
          <MDBox py={3}>
            <Grid container spacing={3}>
              <Grid item md={12} lg={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <ComplexStatisticsCard
                      color="dark"
                      icon="account_balance_wallet"
                      title="Month to date revenue"
                      isAmount={true}
                      count={amountToShow(
                        currentMonthStatistics.totalRevenue || 0
                      )}
                      percentage={{
                        color: `${
                          get(
                            currentMonthStatistics,
                            "currentMonthRevenueSummary.trend",
                            ""
                          ) === "decrease"
                            ? "error"
                            : "success"
                        }`,
                        icon: `${
                          get(
                            currentMonthStatistics,
                            "currentMonthRevenueSummary.trend",
                            ""
                          ) === "decrease"
                            ? "down"
                            : "up"
                        }`,
                        amount: `${get(
                          currentMonthStatistics,
                          "currentMonthRevenueSummary.percentChange",
                          0
                        ).toFixed(2)}%`,
                        label: "compared to last month for same period",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ComplexStatisticsCard
                      color="success"
                      icon="work_history"
                      title="Last month revenue"
                      isAmount={true}
                      count={amountToShow(
                        currentMonthStatistics.sameTimePeriodRevenue || 0
                      )}
                      percentage={{
                        color: `info`,
                        label: `1 ${moment()
                          .subtract(1, "month")
                          .format("MMM")} - ${moment()
                          .subtract(1, "month")
                          .format("D MMM")}`,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ComplexStatisticsCard
                      color="primary"
                      icon="request_quote"
                      title="Current month forecast"
                      isAmount={true}
                      count={amountToShow(
                        (currentMonthStatistics?.transientForecast
                          ?.currentMonthForecastedRevenue || 0) +
                          (currentMonthStatistics?.subscriptionForecast
                            ?.currentMonthForecastedRevenue || 0)
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ComplexStatisticsCard
                      color="secondary"
                      icon="settings_backup_restore"
                      title="Last month revenue"
                      isAmount={true}
                      count={amountToShow(
                        currentMonthStatistics.lastMonthRevenue || 0
                      )}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <MDBox>
                  <VerticalBarChart
                    icon={{ color: "info", component: "bar_chart" }}
                    title="Current Year Transient Revenue"
                    description="Comparison of Transient Revenues"
                    height="300px"
                    chart={{ data: chartData }}
                    type="Revenue"
                    loading={loading}
                    label="Parking"
                  />
                </MDBox>
              </Grid>
            </Grid>
            <Grid container spacing={3} mt={1}>
              <Grid item xs={12} md={12} lg={6}>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <ComplexStatisticsCard
                      color="dark"
                      icon="toys"
                      title={`Month to date bookings`}
                      count={`${currentMonthStatistics.totalBooking || 0}`}
                      percentage={{
                        color: `${
                          get(
                            currentMonthStatistics,
                            "currentMonthBookingSummary.trend",
                            ""
                          ) === "decrease"
                            ? "error"
                            : "success"
                        }`,
                        icon: `${
                          get(
                            currentMonthStatistics,
                            "currentMonthBookingSummary.trend",
                            ""
                          ) === "decrease"
                            ? "down"
                            : "up"
                        }`,
                        amount: `${get(
                          currentMonthStatistics,
                          "currentMonthBookingSummary.percentChange",
                          0
                        ).toFixed(2)}%`,
                        label: "compared to last month for same period",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ComplexStatisticsCard
                      color="success"
                      icon="check_circle"
                      title="Last month bookings"
                      count={`${
                        currentMonthStatistics.sameTimePeriodBooking || 0
                      }`}
                      percentage={{
                        color: `info`,
                        label: `1 ${moment()
                          .subtract(1, "month")
                          .format("MMM")} - ${moment()
                          .subtract(1, "month")
                          .format("D MMM")}`,
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4} mt={1}>
                  <Grid item xs={12} md={6}>
                    <ComplexStatisticsCard
                      color="primary"
                      icon="request_quote"
                      title="Current month forecast"
                      count={`${
                        currentMonthStatistics?.transientForecast
                          ?.currentMonthForecastedBooking || 0
                      }`}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <ComplexStatisticsCard
                      color="secondary"
                      icon="settings_backup_restore"
                      title="Last month's bookings"
                      count={`${currentMonthStatistics.lastMonthBooking || 0}`}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <MDBox>
                  <VerticalBarChart
                    icon={{ color: "info", component: "bar_chart" }}
                    title="Current Year Subscription Revenue"
                    description="Comparison of Subscription Revenues"
                    height="300px"
                    chart={{ data: chartData }}
                    type="Revenue"
                    loading={loading}
                    label="Subscription"
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <MDBox>
                  <VerticalBarChart
                    icon={{ color: "info", component: "bar_chart" }}
                    title="Current Year Bookings"
                    description="Comparison of Transient and Subscription Bookings"
                    height="300px"
                    type="Booking"
                    chart={{ data: chartData }}
                    loading={loading}
                    label="Subscription"
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={12} lg={6}>
                <MDBox>
                  <PieChart
                    type="Revenue"
                    icon={{ color: "info", component: "pie_chart" }}
                    title="Payment Types"
                    description="Revenue comparison of payment types"
                    height="300px"
                    {...(paymentMethodsRevenue &&
                    paymentMethodsRevenue.length > 0
                      ? {
                          chart: {
                            labels: paymentMethodsRevenue.map(
                              (item) => item.paymentMethodType
                            ),
                            datasets: {
                              label: "Revenue",
                              backgroundColors: [
                                "info",
                                "primary",
                                "dark",
                                "secondary",
                              ],
                              data: paymentMethodsRevenue.map(
                                (item) => item.totalRevenue
                              ),
                            },
                          },
                        }
                      : {})}
                  />
                </MDBox>
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <HorizontalBarChart
                    icon={{ color: "success", component: "bar_chart" }}
                    title="Top 5 Locations Revenue wise"
                    description="Comparison of locations"
                    height="300px"
                    type="Revenue"
                    locationsRevenue={locationsRevenue}
                    loading={loading}
                  />
                </MDBox>
              </Grid>
            </Grid>

            <MDBox mt={4}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={3}>
                      <ComplexStatisticsCard
                        color="dark"
                        icon="paid"
                        title="Total Revenue (Subscriptions)"
                        isAmount={true}
                        count={
                          amountToShow(subscriptionStatistics.totalRevenue) || 0
                        }
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <ComplexStatisticsCard
                        color="success"
                        icon="card_membership"
                        title="Total Subscriptions"
                        count={`${
                          subscriptionStatistics.totalSubscriptions || 0
                        }`}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <ComplexStatisticsCard
                        color="primary"
                        icon="badge"
                        title="Active Subscriptions"
                        count={`${
                          subscriptionStatistics.activeSubscriptions || 0
                        }`}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <ComplexStatisticsCard
                        color="secondary"
                        icon="garage"
                        title="Registered License Plates"
                        count={`${
                          subscriptionStatistics.registeredLicensePlates || 0
                        }`}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </MDBox>

            <MDBox mt={3}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6} lg={8}>
                  <Projects data={returningUsersData} />
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                  <OrdersOverview data={topSellingRatesData} />
                </Grid>
              </Grid>
            </MDBox>
          </MDBox>
          <Footer />
          <CircularIndeterminate
            type="full"
            size={20}
            text=""
            open={isLoading}
          />
        </>
      )}
    </DashboardLayout>
  );
}

export default Dashboard;
